import { useContext, useEffect, useState } from 'react'
import VehiclesTable from '../components/vehicle/VehicleTable'
import { getRequest } from '../services/base'
import { useSearchParams } from 'react-router-dom'
import { NavContext } from '../context/global_context'
import { PageHeaders } from '../config/PageHeaders'
import {
  deleteLocalStorage,
  setLocalStorageData,
} from '../utils/LocalStorageAccess'

const Vehicle = () => {
  const [value, dispatch] = useContext(NavContext)
  const [searchParams, setSearchParams] = useSearchParams()
  const [vehiclesData, setVehiclesData] = useState([])
  const [pagination, setPagination] = useState({
    count: 0,
    next: null,
    previous: null,
    current_page: 1,
  })

  useEffect(() => {
    dispatch({
      type: 'header',
      data: { ...PageHeaders.vehicle, show_back_btn: false, dtc_details: {} },
    })

    deleteLocalStorage('dtcs_list')
    getVehicles(null)

    return () => {
      let queryParams = {}
      searchParams.forEach((value, key) => {
        queryParams[key] = value
      })
      setLocalStorageData('vehicle', queryParams)
    }
  }, [])

  const getVehicles = async (url) => {
    let response = await getRequest(
      url
        ? url
        : `/api/vehicles/?search=${
            searchParams.get('search') ? searchParams.get('search') : ''
          }`
    )
    setVehiclesData(response.results)
    setPagination(response.pagination)
  }

  return (
    <VehiclesTable
      vehicles={vehiclesData}
      pagination={pagination}
      getPaginatedData={(url) => {
        getVehicles(url)
      }}
    />
  )
}

export default Vehicle
